<template>
  <div class="container--fluid">
    <SubMenuHeader
      :title="$t('welcomeScreen.pageTitle')"
      :show-back-button="false"
      @showVideo="showVideo"
    />
    <VideoModal v-if="videoEnabled" :show="showVideoModal" :show-note="showNoteInVideo" @dismiss="dismissHandler" />
    <div class="d-flex flex-column justify-content-center align-items-center vh-100">
      <smtt-icon class="mt-10 mb-5" icon="check-circle" color="green" width="100" />
      <div class="h3 mb-5">
        {{ $t('loginSuccess.successful.label') }}
      </div>
    </div>
  </div>
</template>

<script>
import SubMenuHeader from "@/components/SubMenuHeader";
import VideoModal from "@/components/SharedComponents/VideoModal";
import store from "@/store/store";
export default {
  name: "LoginSuccess",
  components: { VideoModal, SubMenuHeader },
  data: () => {
    return {
      'videoEnabled': this.$store.state.isTutorialVideoEnabled,
      'showVideoModal': store.state.showVideoTutorial,
      'showNoteInVideo': true,
    }
  },
  methods: {
    showVideo() {
      if (this.videoEnabled) {
        this.showVideoModal = true
      }
    },
    dismissHandler() {
      this.showVideoModal = false;
      this.showNoteInVideo = false
    }
  }
}
</script>

<style scoped>

</style>
